var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9EFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 21.25C26.0629 21.25 21.25 26.0629 21.25 32C21.25 37.9371 26.0629 42.75 32 42.75C37.9371 42.75 42.75 37.9371 42.75 32C42.75 26.0629 37.9371 21.25 32 21.25ZM33 28C33 27.4477 32.5523 27 32 27C31.4477 27 31 27.4477 31 28V32C31 32.2652 31.1054 32.5196 31.2929 32.7071L33.2929 34.7071C33.6834 35.0976 34.3166 35.0976 34.7071 34.7071C35.0976 34.3166 35.0976 33.6834 34.7071 33.2929L33 31.5858V28Z",
    fill: "#5335E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b6835bd0b6c1641e54f3814a4bcb9fda.svg";
export { ForwardRef as ReactComponent };